import type { OpenQuestionAnswersForItems } from '../../../../reducers/student/tracking/openQuestionAnswersReducer';
import {
  mapOpenQuestionAnswersFromDto,
  mapOpenQuestionAnswersToDto,
  OpenQuestionAnswersForItemsDTO,
} from '../openQuestionAnswersDto';

const LOCAL_STORAGE_KEY_PREFIX = 'ael_scorm_oq_tracking';

type StoredLearnerInteractionsV1 = {
  v: 1;
  data: string;
};

export type ScormInteractionsLocalStorage = {
  setForLearner: (learnerId: string, answers: OpenQuestionAnswersForItems) => void;
  getForLearner: (learnerId: string) => OpenQuestionAnswersForItems | null;
};

const getLearnerStorageKey = (learnerId: string): string =>
  `${LOCAL_STORAGE_KEY_PREFIX}:${encodeURIComponent(learnerId)}`;

export const createScormInteractionsLocalStorage = (): ScormInteractionsLocalStorage => {
  return {
    setForLearner: (learnerId: string, answers: OpenQuestionAnswersForItems): void => {
      try {
        if (typeof localStorage === 'undefined') return;
        const key = getLearnerStorageKey(learnerId);
        const entry: StoredLearnerInteractionsV1 = {
          v: 1,
          data: JSON.stringify(mapOpenQuestionAnswersToDto(answers)),
        };
        localStorage.setItem(key, JSON.stringify(entry));
      } catch {
        // localStorage not available
      }
    },
    getForLearner: (learnerId: string): OpenQuestionAnswersForItems | null => {
      try {
        if (typeof localStorage === 'undefined') return null;

        const key = getLearnerStorageKey(learnerId);
        const raw = localStorage.getItem(key);
        if (raw) {
          const parsed = JSON.parse(raw) as StoredLearnerInteractionsV1;
          if (parsed && parsed.v === 1) {
            try {
              return mapOpenQuestionAnswersFromDto(JSON.parse(parsed.data) as OpenQuestionAnswersForItemsDTO);
            } catch {
              return null;
            }
          }
        }

        return null;
      } catch {
        return null;
      }
    },
  };
};
